import(/* webpackMode: "eager", webpackExports: ["PasswordReset"] */ "/app/apps/auth/app/login/password-reset/components/password-reset.tsx");
